<template>
    <input type="number" v-model="value" :min="min" :max="max" :maxlength="6"
        @focus.prevent="onFocus"
        @blur.prevent="onBlur"
        :class="!value || value.length === 0 ? 'is-empty' : ''"
    />
</template>

<script>
    export default {
        name: "NumberInput",
        props: {
            originalValue: [Number, String],
            min: 0,
            max: 0,
            readOnly: { type: Boolean, default: false }
        },
        data() {
            return {
                value: parseInt(this.originalValue, 10) || null
            }
        },
        watch: {
            originalValue(val, newVal) { this.value = this.originalValue }
        },
        methods: {
            onFocus(event) {
                if (!this.readOnly) {
                    event.target.select()
                } else {
                    this.$emit("click", event);
                }
            },
            onBlur(event) {
                if (this.value === this.originalValue) {
                    // console.log("Values not changed : ", this.originalValue, this.value);
                    return;
                }
                this.$emit("onValueChanged", this.value);
            }
        }
    }
</script>

<style scoped>
    input:invalid {
        border: 1px solid transparent !important;
        border-bottom: 1px solid red !important;
    }
</style>
